module.exports = __webpack_public_path__ + "img/icon-info-white-gray.90bbbb0f.svg";